import BaseModel from "../../../common/database/firestore-base/entities/BaseModel";

export default class Message extends BaseModel {
	constructor(options) {
		super(options);
		typeof options.user !== "undefined" && (this.user = options.user);
		typeof options.text !== "undefined" && (this.text = options.text);
	}
}
